import { Select2Data } from "ng-select2-component"

export const countryCodes: Select2Data = [{
    label: '+971',
    value: '971',
    data: {
      class: 'ae',
      code: '+971'
    }
  },
  {
    label: '+974',
    value: '974',
    data: {
      class: 'qa',
      code: '+974'
    }
  },
  {
    label: '+968',
    value: '968',
    data: {
      class: 'om',
      code: '+968'
    }
  },
  {
    label: '+973',
    value: '973',
    data: {
      class: 'bh',
      code: '+973'
    }
  },
  {
    label: '+965',
    value: '965',
    data: {
      class: 'kw',
      code: '+965'
    }
  },
  {
    label: '+212',
    value: '212',
    data: {
      class: 'ma',
      code: '+212'
    }
  },
  {
    label: '+93',
    value: '93',
    data: {
      class: 'af',
      code: '+93'
    }
  },
  {
    label: '+355',
    value: '355',
    data: {
      class: 'al',
      code: '+355'
    }
  },
  {
    label: '+213',
    value: '213',
    data: {
      class: 'dz',
      code: '+213'
    }
  },
  {
    label: '+1684',
    value: '1684',
    data: {
      class: 'as',
      code: '+1684'
    }
  },
  {
    label: '+376',
    value: '376',
    data: {
      class: 'ad',
      code: '+376'
    }
  },
  {
    label: '+244',
    value: '244',
    data: {
      class: 'ao',
      code: '+244'
    }
  },
  {
    label: '+1264',
    value: '1264',
    data: {
      class: 'ai',
      code: '+1264'
    }
  },
  {
    label: '+1268',
    value: '1268',
    data: {
      class: 'ag',
      code: '+1268'
    }
  },
  {
    label: '+54',
    value: '54',
    data: {
      class: 'ar',
      code: '+54'
    }
  },
  {
    label: '+374',
    value: '374',
    data: {
      class: 'am',
      code: '+374'
    }
  },
  {
    label: '+297',
    value: '297',
    data: {
      class: 'aw',
      code: '+297'
    }
  },
  {
    label: '+61',
    value: '61',
    data: {
      class: 'au',
      code: '+61'
    }
  },
  {
    label: '+43',
    value: '43',
    data: {
      class: 'at',
      code: '+43'
    }
  },
  {
    label: '+994',
    value: '994',
    data: {
      class: 'az',
      code: '+994'
    }
  },
  {
    label: '+1242',
    value: '1242',
    data: {
      class: 'bs',
      code: '+1242'
    }
  },
  {
    label: '+973',
    value: '973',
    data: {
      class: 'bh',
      code: '+973'
    }
  },
  {
    label: '+880',
    value: '880',
    data: {
      class: 'bd',
      code: '+880'
    }
  },
  {
    label: '+1246',
    value: '1246',
    data: {
      class: 'bb',
      code: '+1246'
    }
  },
  {
    label: '+375',
    value: '375',
    data: {
      class: 'by',
      code: '+375'
    }
  },
  {
    label: '+32',
    value: '32',
    data: {
      class: 'be',
      code: '+32'
    }
  },
  {
    label: '+501',
    value: '501',
    data: {
      class: 'bz',
      code: '+501'
    }
  },
  {
    label: '+229',
    value: '229',
    data: {
      class: 'bj',
      code: '+229'
    }
  },
  {
    label: '+1441',
    value: '1441',
    data: {
      class: 'bm',
      code: '+1441'
    }
  },
  {
    label: '+975',
    value: '975',
    data: {
      class: 'bt',
      code: '+975'
    }
  },
  {
    label: '+591',
    value: '591',
    data: {
      class: 'bo',
      code: '+591'
    }
  },
  {
    label: "+387",
    value: "387",
    data: {
      class: "ba",
      code: ' 387'
    }
  },
  {
    label: "+267",
    value: "267",
    data: {
      class: "bw",
      code: ' 267'
    }
  },
  {
    label: "+55",
    value: "55",
    data: {
      class: 'br',
      code: '+55'
    }
  },
  {
    label: "+246",
    value: "246",
    data: {
      class: 'io',
      code: '+246'
    }
  },
  {
    label: "+1284",
    value: "1284",
    data: {
      class: 'vg',
      code: '+1284'
    }
  },
  {
    label: "+673",
    value: "673",
    data: {
      class: 'bn',
      code: '+673'
    }
  },
  {
    label: "+359",
    value: "359",
    data: {
      class: 'bg',
      code: '+359'
    }
  },
  {
    label: "+226",
    value: "226",
    data: {
      class: 'bf',
      code: '+226'
    }
  },
  {
    label: "+257",
    value: "257",
    data: {
      class: 'bi',
      code: '+257'
    }
  },
  {
    label: "+855",
    value: "855",
    data: {
      class: 'kh',
      code: '+855'
    }
  },
  {
    label: "+237",
    value: "237",
    data: {
      class: 'cm',
      code: '+237'
    }
  },
  {
    label: "+1",
    value: "1",
    data: {
      class: 'ca',
      code: '+1'
    }
  },
  {
    label: "+238",
    value: "238",
    data: {
      class: 'cv',
      code: '+238'
    }
  },
  {
    label: "+599",
    value: "599",
    data: {
      class: 'bq',
      code: '+599'
    }
  },
  {
    label: "+1345",
    value: "1345",
    data: {
      class: 'ky',
      code: '+1345'
    }
  },
  {
    label: "+236",
    value: "236",
    data: {
      class: 'cf',
      code: '+236'
    }
  },
  {
    label: "+235",
    value: "235",
    data: {
      class: 'td',
      code: '+235'
    }
  },
  {
    label: "+56",
    value: "56",
    data: {
      class: 'cl',
      code: '+56'
    }
  },
  {
    label: "+86",
    value: "86",
    data: {
      class: 'cn',
      code: '+86'
    }
  },
  {
    label: "+61",
    value: "61",
    data: {
      class: 'cx',
      code: '+61'
    }
  },
  {
    label: "+61",
    value: "61",
    data: {
      class: 'cc',
      code: '+61'
    }
  },
  {
    label: "+57",
    value: "57",
    data: {
      class: 'co',
      code: '+57'
    }
  },
  {
    label: "+269",
    value: "269",
    data: {
      class: 'km',
      code: '+269'
    }
  },
  {
    label: "+243",
    value: "243",
    data: {
      class: 'cd',
      code: '+243'
    }
  },
  {
    label: "+242",
    value: "242",
    data: {
      class: 'cg',
      code: '+242'
    }
  },
  {
    label: "+682",
    value: "682",
    data: {
      class: 'ck',
      code: '+682'
    }
  },
  {
    label: "+506",
    value: "506",
    data: {
      class: 'cr',
      code: '+506'
    }
  },
  {
    label: "+225",
    value: "225",
    data: {
      class: 'ci',
      code: '+225'
    }
  },
  {
    label: "+385",
    value: "385",
    data: {
      class: 'hr',
      code: '+385'
    }
  },
  {
    label: "+53",
    value: "53",
    data: {
      class: 'cu',
      code: '+53'
    }
  },
  {
    label: "+599",
    value: "599",
    data: {
      class: 'cw',
      code: '+599'
    }
  },
  {
    label: "+357",
    value: "357",
    data: {
      class: 'cy',
      code: '+357'
    }
  },
  {
    label: "+420",
    value: "420",
    data: {
      class: 'cz',
      code: '+420'
    }
  },
  {
    label: "+45",
    value: "45",
    data: {
      class: 'dk',
      code: '+45'
    }
  },
  {
    label: "+253",
    value: "253",
    data: {
      class: 'dj',
      code: '+253'
    }
  },
  {
    label: "+1767",
    value: "1767",
    data: {
      class: 'dm',
      code: '+1767'
    }
  },
  {
    label: "+1",
    value: "1",
    data: {
      class: 'do',
      code: '+1'
    }
  },
  {
    label: "+593",
    value: "593",
    data: {
      class: 'ec',
      code: '+593'
    }
  },
  {
    label: "+20",
    value: "20",
    data: {
      class: 'eg',
      code: '+20'
    }
  },
  {
    label: "+503",
    value: "503",
    data: {
      class: 'sv',
      code: '+503'
    }
  },
  {
    label: "+240",
    value: "240",
    data: {
      class: 'gq',
      code: '+240'
    }
  },
  {
    label: "+291",
    value: "291",
    data: {
      class: 'er',
      code: '+291'
    }
  },
  {
    label: "+372",
    value: "372",
    data: {
      class: 'ee',
      code: '+372'
    }
  },
  {
    label: "+251",
    value: "251",
    data: {
      class: 'et',
      code: '+251'
    }
  },
  {
    label: "+500",
    value: "500",
    data: {
      class: 'fk',
      code: '+500'
    }
  },
  {
    label: "+298",
    value: "298",
    data: {
      class: 'fo',
      code: '+298'
    }
  },
  {
    label: "+679",
    value: "679",
    data: {
      class: 'fj',
      code: '+679'
    }
  },
  {
    label: "+358",
    value: "358",
    data: {
      class: 'fi',
      code: '+358'
    }
  },
  {
    label: "+33",
    value: "33",
    data: {
      class: 'fr',
      code: '+33'
    }
  },
  {
    label: "+594",
    value: "594",
    data: {
      class: 'gf',
      code: '+594'
    }
  },
  {
    label: "+689",
    value: "689",
    data: {
      class: 'pf',
      code: '+689'
    }
  },
  {
    label: "+241",
    value: "241",
    data: {
      class: 'ga',
      code: '+241'
    }
  },
  {
    label: "+220",
    value: "220",
    data: {
      class: 'gm',
      code: '+220'
    }
  },
  {
    label: "+995",
    value: "995",
    data: {
      class: 'ge',
      code: '+995'
    }
  },
  {
    label: "+49",
    value: "49",
    data: {
      class: 'de',
      code: '+49'
    }
  },
  {
    label: "+233",
    value: "233",
    data: {
      class: 'gh',
      code: '+233'
    }
  },
  {
    label: "+350",
    value: "350",
    data: {
      class: 'gi',
      code: '+350'
    }
  },
  {
    label: "+30",
    value: "30",
    data: {
      class: 'gr',
      code: '+30'
    }
  },
  {
    label: "+299",
    value: "299",
    data: {
      class: 'gl',
      code: '+299'
    }
  },
  {
    label: "+1473",
    value: "1473",
    data: {
      class: 'gd',
      code: '+1473'
    }
  },
  {
    label: "+590",
    value: "590",
    data: {
      class: 'gp',
      code: '+590'
    }
  },
  {
    label: "+1671",
    value: "1671",
    data: {
      class: 'gu',
      code: '+1671'
    }
  },
  {
    label: "+502",
    value: "502",
    data: {
      class: 'gt',
      code: '+502'
    }
  },
  {
    label: "+44",
    value: "44",
    data: {
      class: 'gg',
      code: '+44'
    }
  },
  {
    label: "+224",
    value: "224",
    data: {
      class: 'gn',
      code: '+224'
    }
  },
  {
    label: "+245",
    value: "245",
    data: {
      class: 'gw',
      code: '+245'
    }
  },
  {
    label: "+592",
    value: "592",
    data: {
      class: 'gy',
      code: '+592'
    }
  },
  {
    label: "+509",
    value: "509",
    data: {
      class: 'ht',
      code: '+509'
    }
  },
  {
    label: "+504",
    value: "504",
    data: {
      class: 'hn',
      code: '+504'
    }
  },
  {
    label: "+852",
    value: "852",
    data: {
      class: 'hk',
      code: '+852'
    }
  },
  {
    label: "+36",
    value: "36",
    data: {
      class: 'hu',
      code: '+36'
    }
  },
  {
    label: "+354",
    value: "354",
    data: {
      class: 'is',
      code: '+354'
    }
  },
  {
    label: "+91",
    value: "91",
    data: {
      class: 'in',
      code: '+91'
    }
  },
  {
    label: "+62",
    value: "62",
    data: {
      class: 'id',
      code: '+62'
    }
  },
  {
    label: "+98",
    value: "98",
    data: {
      class: 'ir',
      code: '+98'
    }
  },
  {
    label: "+964",
    value: "964",
    data: {
      class: 'iq',
      code: '+964'
    }
  },
  {
    label: "+353",
    value: "353",
    data: {
      class: 'ie',
      code: '+353'
    }
  },
  {
    label: "+44",
    value: "44",
    data: {
      class: 'im',
      code: '+44'
    }
  },
  {
    label: "+972",
    value: "972",
    data: {
      class: 'il',
      code: '+972'
    }
  },
  {
    label: "+39",
    value: "39",
    data: {
      class: 'it',
      code: '+39'
    }
  },
  {
    label: "+1876",
    value: "1876",
    data: {
      class: 'jm',
      code: '+1876'
    }
  },
  {
    label: "+81",
    value: "81",
    data: {
      class: 'jp',
      code: '+81'
    }
  },
  {
    label: "+44",
    value: "44",
    data: {
      class: 'je',
      code: '+44'
    }
  },
  {
    label: "+962",
    value: "962",
    data: {
      class: 'jo',
      code: '+962'
    }
  },
  {
    label: "+7",
    value: "7",
    data: {
      class: 'kz',
      code: '+7'
    }
  },
  {
    label: "+254",
    value: "254",
    data: {
      class: 'ke',
      code: '+254'
    }
  },
  {
    label: "+686",
    value: "686",
    data: {
      class: 'ki',
      code: '+686'
    }
  },
  {
    label: "+383",
    value: "383",
    data: {
      class: 'xk',
      code: '+383'
    }
  },
  {
    label: "+965",
    value: "965",
    data: {
      class: 'kw',
      code: '+965'
    }
  },
  {
    label: "+996",
    value: "996",
    data: {
      class: 'kg',
      code: '+996'
    }
  },
  {
    label: "+856",
    value: "856",
    data: {
      class: 'la',
      code: '+856'
    }
  },
  {
    label: "+371",
    value: "371",
    data: {
      class: 'lv',
      code: '+371'
    }
  },
  {
    label: "+961",
    value: "961",
    data: {
      class: 'lb',
      code: '+961'
    }
  },
  {
    label: "+266",
    value: "266",
    data: {
      class: 'ls',
      code: '+266'
    }
  },
  {
    label: "+231",
    value: "231",
    data: {
      class: 'lr',
      code: '+231'
    }
  },
  {
    label: "+218",
    value: "218",
    data: {
      class: 'ly',
      code: '+218'
    }
  },
  {
    label: "+423",
    value: "423",
    data: {
      class: 'li',
      code: '+423'
    }
  },
  {
    label: "+370",
    value: "370",
    data: {
      class: 'lt',
      code: '+370'
    }
  },
  {
    label: "+352",
    value: "352",
    data: {
      class: 'lu',
      code: '+352'
    }
  },
  {
    label: "+853",
    value: "853",
    data: {
      class: 'mo',
      code: '+853'
    }
  },
  {
    label: "+389",
    value: "389",
    data: {
      class: 'mk',
      code: '+389'
    }
  },
  {
    label: "+261",
    value: "261",
    data: {
      class: 'mg',
      code: '+261'
    }
  },
  {
    label: "+265",
    value: "265",
    data: {
      class: 'mw',
      code: '+265'
    }
  },
  {
    label: "+60",
    value: "60",
    data: {
      class: 'my',
      code: '+60'
    }
  },
  {
    label: "+960",
    value: "960",
    data: {
      class: 'mv',
      code: '+960'
    }
  },
  {
    label: "+223",
    value: "223",
    data: {
      class: 'ml',
      code: '+223'
    }
  },
  {
    label: "+356",
    value: "356",
    data: {
      class: 'mt',
      code: '+356'
    }
  },
  {
    label: "+692",
    value: "692",
    data: {
      class: 'mh',
      code: '+692'
    }
  },
  {
    label: "+596",
    value: "596",
    data: {
      class: 'mq',
      code: '+596'
    }
  },
  {
    label: "+222",
    value: "222",
    data: {
      class: 'mr',
      code: '+222'
    }
  },
  {
    label: "+230",
    value: "230",
    data: {
      class: 'mu',
      code: '+230'
    }
  },
  {
    label: "+262",
    value: "262",
    data: {
      class: 'yt',
      code: '+262'
    }
  },
  {
    label: "+52",
    value: "52",
    data: {
      class: 'mx',
      code: '+52'
    }
  },
  {
    label: "+691",
    value: "691",
    data: {
      class: 'fm',
      code: '+691'
    }
  },
  {
    label: "+373",
    value: "373",
    data: {
      class: 'md',
      code: '+373'
    }
  },
  {
    label: "+377",
    value: "377",
    data: {
      class: 'mc',
      code: '+377'
    }
  },
  {
    label: "+976",
    value: "976",
    data: {
      class: 'mn',
      code: '+976'
    }
  },
  {
    label: "+382",
    value: "382",
    data: {
      class: 'me',
      code: '+382'
    }
  },
  {
    label: "+1664",
    value: "1664",
    data: {
      class: 'ms',
      code: '+1664'
    }
  },
  {
    label: "+212",
    value: "212",
    data: {
      class: 'ma',
      code: '+212'
    }
  },
  {
    label: "+258",
    value: "258",
    data: {
      class: 'mz',
      code: '+258'
    }
  },
  {
    label: "+95",
    value: "95",
    data: {
      class: 'mm',
      code: '+95'
    }
  },
  {
    label: "+264",
    value: "264",
    data: {
      class: 'na',
      code: '+264'
    }
  },
  {
    label: "+674",
    value: "674",
    data: {
      class: 'nr',
      code: '+674'
    }
  },
  {
    label: "+977",
    value: "977",
    data: {
      class: 'np',
      code: '+977'
    }
  },
  {
    label: "+31",
    value: "31",
    data: {
      class: 'nl',
      code: '+31'
    }
  },
  {
    label: "+687",
    value: "687",
    data: {
      class: 'nc',
      code: '+687'
    }
  },
  {
    label: "+64",
    value: "64",
    data: {
      class: 'nz',
      code: '+64'
    }
  },
  {
    label: "+505",
    value: "505",
    data: {
      class: 'ni',
      code: '+505'
    }
  },
  {
    label: "+227",
    value: "227",
    data: {
      class: 'ne',
      code: '+227'
    }
  },
  {
    label: "+234",
    value: "234",
    data: {
      class: 'ng',
      code: '+234'
    }
  },
  {
    label: "+683",
    value: "683",
    data: {
      class: 'nu',
      code: '+683'
    }
  },
  {
    label: "+672",
    value: "672",
    data: {
      class: 'nf',
      code: '+672'
    }
  },
  {
    label: "+850",
    value: "850",
    data: {
      class: 'kp',
      code: '+850'
    }
  },
  {
    label: "+1670",
    value: "1670",
    data: {
      class: 'mp',
      code: '+1670'
    }
  },
  {
    label: "+47",
    value: "47",
    data: {
      class: 'no',
      code: '+47'
    }
  },
  {
    label: "+968",
    value: "968",
    data: {
      class: 'om',
      code: '+968'
    }
  },
  {
    label: "+92",
    value: "92",
    data: {
      class: 'pk',
      code: '+92'
    }
  },
  {
    label: "+680",
    value: "680",
    data: {
      class: 'pw',
      code: '+680'
    }
  },
  {
    label: "+970",
    value: "970",
    data: {
      class: 'ps',
      code: '+970'
    }
  },
  {
    label: "+507",
    value: "507",
    data: {
      class: 'pa',
      code: '+507'
    }
  },
  {
    label: "+675",
    value: "675",
    data: {
      class: 'pg',
      code: '+675'
    }
  },
  {
    label: "+595",
    value: "595",
    data: {
      class: 'py',
      code: '+595'
    }
  },
  {
    label: "+51",
    value: "51",
    data: {
      class: 'pe',
      code: '+51'
    }
  },
  {
    label: "+63",
    value: "63",
    data: {
      class: 'ph',
      code: '+63'
    }
  },
  {
    label: "+48",
    value: "48",
    data: {
      class: 'pl',
      code: '+48'
    }
  },
  {
    label: "+351",
    value: "351",
    data: {
      class: 'pt',
      code: '+351'
    }
  },
  {
    label: "+1",
    value: "1",
    data: {
      class: 'pr',
      code: '+1'
    }
  },
  {
    label: "+974",
    value: "974",
    data: {
      class: 'qa',
      code: '+974'
    }
  },
  {
    label: "+262",
    value: "262",
    data: {
      class: 're',
      code: '+262'
    }
  },
  {
    label: "+40",
    value: "40",
    data: {
      class: 'ro',
      code: '+40'
    }
  },
  {
    label: "+7",
    value: "7",
    data: {
      class: 'ru',
      code: '+7'
    }
  },
  {
    label: "+250",
    value: "250",
    data: {
      class: 'rw',
      code: '+250'
    }
  },
  {
    label: "+590",
    value: "590",
    data: {
      class: 'bl',
      code: '+590'
    }
  },
  {
    label: "+290",
    value: "290",
    data: {
      class: 'sh',
      code: '+290'
    }
  },
  {
    label: "+1869",
    value: "1869",
    data: {
      class: 'kn',
      code: '+1869'
    }
  },
  {
    label: "+1758",
    value: "1758",
    data: {
      class: 'lc',
      code: '+1758'
    }
  },
  {
    label: "+590",
    value: "590",
    data: {
      class: 'mf',
      code: '+590'
    }
  },
  {
    label: "+508",
    value: "508",
    data: {
      class: 'pm',
      code: '+508'
    }
  },
  {
    label: "+1784",
    value: "1784",
    data: {
      class: 'vc',
      code: '+1784'
    }
  },
  {
    label: "+685",
    value: "685",
    data: {
      class: 'ws',
      code: '+685'
    }
  },
  {
    label: "+378",
    value: "378",
    data: {
      class: 'sm',
      code: '+378'
    }
  },
  {
    label: "+239",
    value: "239",
    data: {
      class: 'st',
      code: '+239'
    }
  },
  {
    label: "+966",
    value: "966",
    data: {
      class: 'sa',
      code: '+966'
    }
  },
  {
    label: "+221",
    value: "221",
    data: {
      class: 'sn',
      code: '+221'
    }
  },
  {
    label: "+381",
    value: "381",
    data: {
      class: 'rs',
      code: '+381'
    }
  },
  {
    label: "+248",
    value: "248",
    data: {
      class: 'sc',
      code: '+248'
    }
  },
  {
    label: "+232",
    value: "232",
    data: {
      class: 'sl',
      code: '+232'
    }
  },
  {
    label: "+65",
    value: "65",
    data: {
      class: 'sg',
      code: '+65'
    }
  },
  {
    label: "+1721",
    value: "1721",
    data: {
      class: 'sx',
      code: '+1721'
    }
  },
  {
    label: "+421",
    value: "421",
    data: {
      class: 'sk',
      code: '+421'
    }
  },
  {
    label: "+386",
    value: "386",
    data: {
      class: 'si',
      code: '+386'
    }
  },
  {
    label: "+677",
    value: "677",
    data: {
      class: 'sb',
      code: '+677'
    }
  },
  {
    label: "+252",
    value: "252",
    data: {
      class: 'so',
      code: '+252'
    }
  },
  {
    label: "+27",
    value: "27",
    data: {
      class: 'za',
      code: '+27'
    }
  },
  {
    label: "+82",
    value: "82",
    data: {
      class: 'kr',
      code: '+82'
    }
  },
  {
    label: "+211",
    value: "211",
    data: {
      class: 'ss',
      code: '+211'
    }
  },
  {
    label: "+34",
    value: "34",
    data: {
      class: 'es',
      code: '+34'
    }
  },
  {
    label: "+94",
    value: "94",
    data: {
      class: 'lk',
      code: '+94'
    }
  },
  {
    label: "+249",
    value: "249",
    data: {
      class: 'sd',
      code: '+249'
    }
  },
  {
    label: "+597",
    value: "597",
    data: {
      class: 'sr',
      code: '+597'
    }
  },
  {
    label: "+47",
    value: "47",
    data: {
      class: 'sj',
      code: '+47'
    }
  },
  {
    label: "+268",
    value: "268",
    data: {
      class: 'sz',
      code: '+268'
    }
  },
  {
    label: "+46",
    value: "46",
    data: {
      class: 'se',
      code: '+46'
    }
  },
  {
    label: "+41",
    value: "41",
    data: {
      class: 'ch',
      code: '+41'
    }
  },
  {
    label: "+963",
    value: "963",
    data: {
      class: 'sy',
      code: '+963'
    }
  },
  {
    label: "+886",
    value: "886",
    data: {
      class: 'tw',
      code: '+886'
    }
  },
  {
    label: "+992",
    value: "992",
    data: {
      class: 'tj',
      code: '+992'
    }
  },
  {
    label: "+255",
    value: "255",
    data: {
      class: 'tz',
      code: '+255'
    }
  },
  {
    label: "+66",
    value: "66",
    data: {
      class: 'th',
      code: '+66'
    }
  },
  {
    label: "+670",
    value: "670",
    data: {
      class: 'tl',
      code: '+670'
    }
  },
  {
    label: "+228",
    value: "228",
    data: {
      class: 'tg',
      code: '+228'
    }
  },
  {
    label: "+690",
    value: "690",
    data: {
      class: 'tk',
      code: '+690'
    }
  },
  {
    label: "+676",
    value: "676",
    data: {
      class: 'to',
      code: '+676'
    }
  },
  {
    label: "+1868",
    value: "1868",
    data: {
      class: 'tt',
      code: '+1868'
    }
  },
  {
    label: "+216",
    value: "216",
    data: {
      class: 'tn',
      code: '+216'
    }
  },
  {
    label: "+90",
    value: "90",
    data: {
      class: 'tr',
      code: '+90'
    }
  },
  {
    label: "+993",
    value: "993",
    data: {
      class: 'tm',
      code: '+993'
    }
  },
  {
    label: "+1649",
    value: "1649",
    data: {
      class: 'tc',
      code: '+1649'
    }
  },
  {
    label: "+688",
    value: "688",
    data: {
      class: 'tv',
      code: '+688'
    }
  },
  {
    label: "+1340",
    value: "1340",
    data: {
      class: 'vi',
      code: '+1340'
    }
  },
  {
    label: "+256",
    value: "256",
    data: {
      class: 'ug',
      code: '+256'
    }
  },
  {
    label: "+380",
    value: "380",
    data: {
      class: 'ua',
      code: '+380'
    }
  },
  {
    label: "+971",
    value: "971",
    data: {
      class: 'ae',
      code: '+971'
    }
  },
  {
    label: "+44",
    value: "44",
    data: {
      class: 'gb',
      code: '+44'
    }
  },
  {
    label: "+1",
    value: "1",
    data: {
      class: 'us',
      code: '+1'
    }
  },
  {
    label: "+598",
    value: "598",
    data: {
      class: 'uy',
      code: '+598'
    }
  },
  {
    label: "+998",
    value: "998",
    data: {
      class: 'uz',
      code: '+998'
    }
  },
  {
    label: "+678",
    value: "678",
    data: {
      class: 'vu',
      code: '+678'
    }
  },
  {
    label: "+39",
    value: "39",
    data: {
      class: 'va',
      code: '+39'
    }
  },
  {
    label: "+58",
    value: "58",
    data: {
      class: 've',
      code: '+58'
    }
  },
  {
    label: "+84",
    value: "84",
    data: {
      class: 'vn',
      code: '+84'
    }
  },
  {
    label: "+681",
    value: "681",
    data: {
      class: 'wf',
      code: '+681'
    }
  },
  {
    label: "+212",
    value: "212",
    data: {
      class: 'eh',
      code: '+212'
    }
  },
  {
    label: "+967",
    value: "967",
    data: {
      class: 'ye',
      code: '+967'
    }
  },
  {
    label: "+260",
    value: "260",
    data: {
      class: 'zm',
      code: '+260'
    }
  },
  {
    label: "+263",
    value: "263",
    data: {
      class: 'zw',
      code: '+263'
    }
  },
  {
    label: "+358",
    value: "358",
    data: {
      class: 'ax',
      code: '+358 '
    }
  }
]


